import { CheckboxButtonGroupValue } from "../../../models/Button";
import { CardElementName } from "../../../models/CardElement";
import CheckboxButtonGroup from "../../Control/Button/CheckboxButtonGroup";
import { ToggleButton } from "../../Control/ToggleButton";
import { ColumnLabel } from "../../Layout/ColumnLabel";

export type ElementSelectorProps = {
    values: CheckboxButtonGroupValue<CardElementName>[],
    update: (values: CheckboxButtonGroupValue<CardElementName>[]) => void,
    isAnd: boolean,
    updateIsAnd: (value: boolean) => void
}

export function ElementSelector(props: ElementSelectorProps) {
    return (
        <ColumnLabel
            label="Element"
            classNames={{ column2: "flex flex-row gap-2" }}
        >
            <ToggleButton value={props.isAnd} update={(value) => props.updateIsAnd(value)} text={{ on: "AND", off: "OR" }} classNames={{ button: "w-[50px] self-baseline"}} />

            <CheckboxButtonGroup
                classNames={{
                    container: "!grid-cols-4 md:!grid-cols-8 flex-1",
                    button: "min-h-[34px]"
                }}
                contentGenerator={(label) => (
                    <span title={label} className={"ff-icon " + label.toLocaleLowerCase()}>
                        <span className="sr-only">{label}</span>
                    </span>
                )}
                values={props.values}
                onClick={(clickedValue, buttonState) => props.update(buttonState)} />
        </ColumnLabel>
    )
}